import { Link } from "react-router-dom"
import { H5, Image, LI } from "../../../../AbstractElements"
import { notificationData } from "../../../../data/layout-data/HeaderData"
import { dynamicImage } from "../../../../service"
import { AddNewBookmark, Href } from "../../../../utils/Constant"
import { useTranslation } from "react-i18next"

const NotificationBox = () => {
    const {t}=useTranslation()
  return (
    <>
        {notificationData.map((data, index) => (
            <div className="d-flex align-items-center" key={index}>
                <Image src={dynamicImage(`dashboard/user/${data.img}`)} alt="Wallet" />
                <div className="flex-grow-1 ms-2">
                    <Link to=''>
                        <H5>{data.title}</H5>
                        <span>{data.subTitle}</span>
                    </Link>
                </div>
                {data.color && 
                    <div className="flex-shrink-0"> 
                        <div className={`activity-dot-${data.color}`}></div>
                    </div>
                }
           
            </div>
        ))}
              <LI className="text-center mb-2">
          <Link className="flip-btn f-w-700" id="flip-btn"  to={`${process.env.PUBLIC_URL}/notification`}>{t("ViewAll")}</Link>
        </LI>
    </>
  )
}

export default NotificationBox